import { ACTIONS } from "./audit.actions";

export const initialState = {
  userCustomerActivityLogs: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.FETCH_AUDIT_LOGS.SUCCESS:
      return {
        ...state,
        userCustomerActivityLogs: action.payload,
      };
    default:
      return state;
  }
};
